import React from "react";
import "./InfoCard.css";
import { Link } from "react-router-dom";
import imgRightArrow from "../../images/icons/DRight_Arrow.png";

const InfoCard = (props) => {
  const getLinkPath = () => {
    switch (props.title) {
      case "Total Member":
        return "/member";
      case "Product":
        return "/product";
      case "Total Reservation":
        return "/reserve";
      case "Total Reward":
        return "/reward/customer";
      case "Promotion":
        return "/promotion";
      default:
        return "/product";
    }
  };
  return (
    <Link to={getLinkPath()} className="info-card"> 
   
      <img src={props.icon} width={props.iconWidth} className="icon" alt="" />

      <div className="title_text card_title">{props.title}</div>

      <div className="d-flex justify-content-between align-items-center mt-8">
        <div className="count">{props.count}</div>
        <div className="sale">{props.sale}</div>
      </div>

      <div className="d-flex justify-content-center">
        <button type="button" className="btnSeeMore">
          <div className="text">See More</div>
          <img
            src={imgRightArrow}
            alt="right-arrow"
            className="imgRightArrow"
          />
        </button>
      </div>
    </Link>
  );
};

export default InfoCard;
